
import BaseInputComponent from "@/components/BaseForm/BaseInput/BaseInputComponent";
export default BaseInputComponent;
